import { render, staticRenderFns } from "./CardCircolareAutomatica_backup.vue?vue&type=template&id=ba545ab0&"
import script from "./CardCircolareAutomatica_backup.vue?vue&type=script&lang=js&"
export * from "./CardCircolareAutomatica_backup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports